export default "__VITE_ASSET__ByzW707R__"